module.exports = __webpack_public_path__ + "static/digia-logo-8d7ae41dcfc2eef06197b960714d9d8d.png";